import Model from './Model';

export default class Maillead2 extends Model {
  resource() {
    return 'lead/list';
  }
}
